import { Component, ElementRef, ViewChild } from '@angular/core';
import { BlockTextArea } from '@src/app/@shared/models/step.model';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';
import { TextAreaHeight } from '@app/components/pl-textarea/pl-textarea.component';

export enum FormControlName {
  textarea = 'textarea',
}

interface TextareaForm {
  [FormControlName.textarea]: FormControl<string>;
}

@Component({
  selector: 'pl-block-textarea',
  templateUrl: './block-textarea.component.html',
})
export class BlockTextareaComponent extends BlockAbstractComponent<BlockTextArea, TextareaForm> {
  protected readonly FormControlName: typeof FormControlName = FormControlName;
  protected readonly TextAreaHeight: typeof TextAreaHeight = TextAreaHeight;

  @ViewChild('plTextarea', { read: ElementRef }) public plTextareaElement!: ElementRef;

  protected override initForm(): void {
    const fb: FormBuilder = new FormBuilder();
    this.form = fb.nonNullable.group<TextareaForm>({
      textarea: fb.nonNullable.control(''),
    });
  }

  protected override patchFormWithEmptyValue(): void {
    if (this.form) {
      this.form.patchValue(
        {
          [FormControlName.textarea]: '',
        },
        { emitEvent: false },
      );
    } else {
      throw new Error(`patchFormWithEmptyValue() this.form should not be null when this function is called`);
    }
  }

  protected override patchFormFromBlock(block: BlockTextArea, valueFromLocalStorage: string | null): void {
    if (this.form) {
      let value: string | null = block.data.value;
      let markFormAsDirtyAndEmitValue: boolean = false;
      if (!value && valueFromLocalStorage) {
        value = valueFromLocalStorage;
        this.form.controls.textarea.markAsDirty();
        markFormAsDirtyAndEmitValue = true;
      }
      this.form.patchValue(
        {
          textarea: value || '',
        },
        { emitEvent: markFormAsDirtyAndEmitValue },
      );
      if (block.data.config.required === '1') {
        this.form.controls.textarea.addValidators(Validators.required);
      } else {
        this.form.controls.textarea.removeValidators(Validators.required);
      }
    } else {
      throw new Error(`patchFormFromBlock() this.form should not be null when this function is called`);
    }
  }

  protected override getUpdatedBlock(): BlockTextArea {
    if (this.form && this.block) {
      const control: AbstractControl | null = this.form.get(FormControlName.textarea);
      if (control) {
        const value: string = control.value;
        this.courseContentService.saveShortCodesInLocalStorage({ [this.block.program_data_code]: value });
        return {
          ...this.block,
          data: {
            ...this.block.data,
            value,
          },
        };
      }
    }

    throw new Error(`getUpdatedBlock() this.form or control should not be null when this function is called`);
  }

  protected override onProgrammaticFocus(): void {
    // preventScroll: true because scroll is handled by directive plScrollToInvalidControlOnSubmit
    this.plTextareaElement.nativeElement.focus({ preventScroll: true });
  }
}
